import React, { useState } from 'react';

import { LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';
import { Dialog } from '@paragon/popup-state';

export function SignUpDialog() {
  const [cancelDisabled, setCancelDisabled] = useState<boolean>(false);

  // `disableRestoreFocus` so that `autoFocus` works (see https://stackoverflow.com/a/76533962/4046605)
  return (
    <Dialog
      variant="design"
      cancelDisabled={cancelDisabled}
      fullWidth
      maxWidth="xs"
      contentSx={{ padding: 0 }}
      disableRestoreFocus
    >
      <LoginScreen hideTermsAndPrivacy>
        <StandardLoginScreenContents signUp setCancelDisabled={setCancelDisabled} />
      </LoginScreen>
    </Dialog>
  );
}
